<template>
  <q-spinner class="information-form__spinner" v-if="loading" />
  <div v-else>

    <div class="text-center" v-if="isEventListLoading">
      <q-spinner v-if="isEventListLoading" color="primary" size="3em" class="q-ma-md" />
      <p class="text-primary">{{ $t('common.loadingEvents') }}</p>
    </div>

    <div class="text-center" v-else-if="eventListLoadFailed || !filteredEvents.length">
      <p class="text-negative">{{ $t('error.fetchEvents') }}</p>
      <q-btn icon="refresh" color="negative" :label="$t('common.refetchEvents')" @click="refetchEvents" />
    </div>

    <div v-else>
      <q-select clearable filled v-model="selectedEvent" :options="filteredEvents" :label="$t('common.event')" class="q-mb-sm race-select" />

      <div v-if="selectedCity" class="q-mb-sm">
        <q-input filled readonly :model-value="selectedCity.label" :label="$t('common.city')" />
      </div>
      <div v-if="selectedCountry" class="q-mb-sm">
        <q-input filled readonly :model-value="selectedCountry.label" :label="$t('common.country')" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      selectedCountry: null,
      selectedCity: null,
      selectedEvent: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters("global", ["getFormData"]),
    ...mapState({
      isEventListLoading: (state) => state.global.isEventListLoading,
      eventListLoadFailed: (state) => state.global.eventListLoadFailed,
      citiesList: (state) => state.global.citiesList,
      countriesList: (state) => state.global.countriesList,
      selectEventsList: (state) => state.global.selectEventsList,
    }),
    cities() {
      return this.citiesList;
    },
    countries() {
      return this.countriesList;
    },
    events() {
      return this.selectEventsList;
    },
    filteredEvents() {
      return [...this.events].sort((a, b) => Number(b.gear_date) - Number(a.gear_date));
    }
  },
  methods: {
    ...mapActions("global", ["fetchEventsForSelect"]),
    async refetchEvents() {
      await this.fetchEventsForSelect();
    },
    updateFormDataAndEmit(event) {
      if (!event) {
        this.selectedCity = null;
        this.selectedCountry = null;
        this.$emit("setCity", null);
        this.$emit("setCountry", null);
        return;
      }
      let cityId = event.assign_city;
      if (cityId) {
        this.selectedCity = this.cities.find((c) => c.id == cityId) || null;
        this.selectedCountry = this.countries.find(
          (c) =>
            (Array.isArray(c.acf?.assign_cities) && c.acf.assign_cities.some((id) => id == cityId)) ||
            c.id == this.selectedCity?.acf?.assign_country
        ) || null;
        this.$emit("setCity", this.selectedCity);
        this.$emit("setCountry", this.selectedCountry);
      }

      this.$emit("setEvent", event);
    }
  },
  watch: {
    selectedEvent(val) {
      this.updateFormDataAndEmit(val);
    },
    countries() {
      if (this.selectedEvent) {
        this.updateFormDataAndEmit(this.selectedEvent);
      }
    },
  },
  async mounted() {
    const formData = this.getFormData;
    if (formData && formData.event) {
      const initialEvent = this.events.find((el) => el.id === formData.event);
      this.selectedEvent = initialEvent;
      this.updateFormDataAndEmit(initialEvent);
    }
  }
};
</script>

<style lang="scss" scoped>
.information-form {
  &__spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.race-select :deep .q-field__inner .q-field__control {
  border: 1px solid #ccc;
  background-color: white;
}
</style>